export const ResourceData = {
  videos: [
    {
      title: "IBM Introduction to AI",
      link: "https://www.coursera.org/learn/introduction-to-ai",
    },
    {
      title: "IBM Machine Learning Professional Certificate",
      link: "https://www.coursera.org/professional-certificates/ibm-machine-learning?utm_medium=sem&utm_source=gg&utm_campaign=B2C_NAMER_ibm-machine-learning_ibm_FTCOF_professional-certificates_country-US-country-CA&campaignid=20524101542&adgroupid=156213436787&device=c&keyword=machine%20learning%20course&matchtype=b&network=g&devicemodel=&adposition=&creativeid=672978172752&hide_mobile_promo&gad_source=1&gclid=CjwKCAjw5ImwBhBtEiwAFHDZx5OM1aoJvOsGUtk3FACtxN13is82Ay2g-m79lCA6J-_aSbTaU4lCshoCbXsQAvD_BwE",
    },
    {
      title: "Stanford Machine Learning Specialization",
      link: "https://www.coursera.org/specializations/machine-learning-introduction",
    },
    {
      title: "freeCodeCamp Machine Learning for Everybody - Full Course",
      link: "https://www.youtube.com/watch?v=i_LwzRVP7bg",
    },
    {
      title: "Course on Convolutional Neural Networks ",
      link: "https://www.mygreatlearning.com/academy/learn-for-free/courses/convolutional-neural-networks",
    },
  ],

  readings: [
    {
      title: "Readings in Artificial Intelligence",
      link: "https://www.sciencedirect.com/book/9780934613033/readings-in-artificial-intelligence",
    },
    {
      title: "Unpacking the 'Black Box' of AI Education",
      link: "https://www.jstor.org/stable/48707970",
    },
    {
      title:
        "Exploring the Potential of Generative Artificial Intelligence in Education: Applications, Challenges, and Future Research Directions",
      link: "https://drive.google.com/file/d/15zj51LzLpsE-LE-04WMycl4uvFTOn8x-/view",
    },
    {
      title: "Revolutionizing Agriculture with Artificial Intelligence",
      link: "https://doi.org/10.3389/fpls.2024.1356260",
    },
    {
      title:
        "Performance analysis of AI-based solutions for crop disease identification, detection, and classification",
      link: "https://doi.org/10.1016/j.atech.2023.100238",
    },
    {
      title: "Image-based crop disease detection with federated learning",
      link: "https://www.nature.com/articles/s41598-023-46218-5",
    },
  ],
};
